// removed by extract-text-webpack-plugin
module.exports = {"container":"src-styles----contact-module---container---HgCNH","title":"src-styles----contact-module---title---2ALNL","contactInput":"src-styles----contact-module---contactInput---URLOC","contactFlex":"src-styles----contact-module---contactFlex---RnC7q","logoWrapper":"src-styles----contact-module---logoWrapper---1NXTz","logo":"src-styles----contact-module---logo---2-zRO","tagline":"src-styles----contact-module---tagline---1N7hX"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/contact.module.css
// module id = 315
// module chunks = 70144966829960